import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './State';

export const profleReducer = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    profileInfoAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.profilInfo = action.payload;
    },
    insuranceListingAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.insuranceListing = action.payload;
    },
    programContactsAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.programContacts = action.payload;
    },
    apiMessageCodeAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.statusAndMsg = action.payload;
    },
    allowDonorPhotoUploadAction: (state, action) => {
      // eslint-disable-next-line no-param-reassign
      state.allowDonorPhotoUpload = action.payload;
    }
  }
});

export const {
  profileInfoAction, insuranceListingAction, programContactsAction, apiMessageCodeAction, allowDonorPhotoUploadAction
} = profleReducer.actions;

export default profleReducer.reducer;
